;(function () {
	window.clickOff = function ($el, callback) {
		if (!$el) return false;
		$(document).on('click', function (e) {
			if ($el.has(e.target).length === 0 && !$el.is(e.target)) {
				callback($el);
			}
		});
	};
}());

$(function () {
	/* open menu */
	$('[data-toggle="menu"]').on('click', function () {
		$(this).toggleClass('b-burger_active');
		// $('.b-h__menu').toggleClass('b-h__menu_opened');
		$('.b-h__item_middle').toggleClass('b-h__item_middle_opened');
		$('body').toggleClass('_overflow');
		$('.b-h').toggleClass('b-h_active').css({'z-index': '15'});
	});

	$('.overlay').on('click', function () {
		if ($('.b-h__menu').hasClass('b-h__menu_opened')) {
			$('body').removeClass('_overflow');
			// $('.b-h__menu').removeClass('b-h__menu_opened');
			$('.b-h__item_middle').removeClass('b-h__item_middle_opened');
			$('.b-h').removeClass('b-h_active').css({'z-index': '1'});
			$('.b-burger').removeClass('b-burger_active');
		}
	});
});

// stickyMenu
// bind magnific-popup links
function bindIFrameLinks($link) {
	$link = $link || $('[data-toggle="iframe"], [data-toggle="modal"][data-type="iframe"]');

	$link.each(function () {
		var $linkItem = $(this);
		if ($linkItem.data('href')) {
			$linkItem.attr('href', $linkItem.data('href'));
		}

		$linkItem.magnificPopup({
			type: 'iframe',
			preloader: true,
			modal: true,
			showCloseBtn: true,
		});
	});
};


$(function() {
	bindIFrameLinks();
});

// скрыть/раскрыть вакансию
$(function () {
	$('[data-toggle="spoiler"]').on('click', function (e) {
		$(this).toggleClass('icon--minus').toggleClass('icon--plus');
		$(this).parents(".b-opener__head").siblings(".b-opener__body").slideToggle(400);
	});
});

// показать ссылку Показать в карточке отзывов
$(function () {
	$(".b-reviewCard__bottom").each(function() {
		let th = $(this);
		if (th.prop('scrollHeight') > th.height()) {
			th.next(".b-reviewCard__more").show();
		}
	});
});
